// NOTE Language Images ---

import { BiBadgeCheck, BiMessageSquareDots } from "react-icons/bi";

import avatar1 from "../../images/users/avatar-2.jpg";
import avatar3 from "../../images/users/avatar-3.jpg";
import avatar4 from "../../images/users/avatar-6.jpg";
import avatar2 from "../../images/users/avatar-8.jpg";

// NOTE Nav Notifications Data ****
export const notificationsData = [
  {
    id: "all-notification",
    label: "All",
    content: [
      {
        id: "noti-1",
        type: "general",
        notificationText: `Your Elite author Graphic Optimization reward is ready!`,
        time: "JUST 30 SEC AGO",
        icon: <BiBadgeCheck size={15} color="#41A3DC" />,
        iconBgColor: "#DFF0FA",
      },
      {
        id: "noti-2",
        type: "user",
        username: "Angela Bernier",
        notificationText:
          "Answered to your comment on the cash flow forecast's graph 🔔.",
        time: "48 MIN AGO",
        userImage: avatar1,
      },
      {
        id: "noti-3",
        type: "general",
        notificationText:
          "You have received 20 new messages in the conversation",
        time: "2 HRS AGO",
        icon: <BiMessageSquareDots size={15} color="#F06548" />,
        iconBgColor: "#FDE8E4",
      },
      {
        id: "noti-4",
        type: "user",
        username: "Maureen Gibson",
        notificationText: "We talked about a project on linkedin.",
        time: "4 HRS AGO",
        userImage: avatar2,
      },
    ],
  },
  {
    id: "all-message-notifications",
    label: "Messages",
    content: [
      {
        id: "msg-noti-1",
        type: "user",
        username: "James Lemire",
        notificationText: "We talked about a project on linkedin.",
        time: "30 MIN AGO",
        userImage: avatar3,
      },
      {
        id: "msg-noti-2",
        type: "user",
        username: "Angela Bernier",
        notificationText:
          "Answered to your comment on the cash flow forecast's graph 🔔.",
        time: "2 HRS AGO",
        userImage: avatar1,
      },
      {
        id: "msg-noti-3",
        type: "user",
        username: "Kenneth Brown",
        notificationText: "Mentionned you in his comment on 📃 invoice #12501.",
        time: "10 HRS AGO",
        userImage: avatar4,
      },
      {
        id: "msg-noti-4",
        type: "user",
        username: "Maureen Gibson",
        notificationText: "We talked about a project on linkedin.",
        time: "3 DAYS AGO",
        userImage: avatar2,
      },
    ],
  },
  {
    id: "all-alert-notifications",
    label: "Alerts",
    content: [],
  },
];

// PUBLIC NAVBAR LINKS (MAIN)
export const menuTree = [
  {
    _id: "menu-home-parent",
    name: "Home",
    link: "/",
    children: [],
  },
  {
    _id: "menu-about-us-parent",
    name: "About Us",
    link: "/about-us/about-fujairah",
    children: [
      {
        _id: "menu-about-us-child-1",
        name: "Mission Statement",
        link: "/about-us/mission-statement?innerTab=our-vision",
        children: [],
      },
      {
        _id: "menu-about-us-child-2",
        name: "Messages",
        link: "/about-us/messages?innerTab=chairmans-message",
        children: [],
      },
      // {
      //   _id: "menu-about-us-child-3",
      //   name: "Organization Structure",
      //   link: "#",
      //   children: [],
      // },
    ],
  },
  {
    _id: "menu-start-your-business-parent",
    name: "Start Your Business",
    link: "/start-your-business",
    children: [
      {
        _id: "menu-start-your-business-child-1",
        name: "Virtual Offices",
        link: "/start-your-business/virtual-offices",
        children: [],
      },
      {
        _id: "menu-start-your-business-child-2",
        name: "Flexi Desk",
        link: "/start-your-business/flexi-desk",
        children: [],
      },
      {
        _id: "menu-start-your-business-child-3",
        name: "Representative / Branch Offices",
        link: "/start-your-business/representative-branch-offices",
        children: [],
      },
      {
        _id: "menu-start-your-business-child-4",
        name: "Warehouse",
        link: "/start-your-business/warehouse",
        children: [],
      },
      {
        _id: "menu-start-your-business-child-5",
        name: "Open Land",
        link: "/start-your-business/open-land",
        children: [],
      },
      {
        _id: "menu-start-your-business-child-6",
        name: "Custom Build Units",
        link: "/start-your-business/custom-build-units",
        children: [],
      },
      {
        _id: "menu-start-your-business-child-7",
        name: "Overseas Company (Offshore)",
        link: "/start-your-business/overseas-company-offshore",
        children: [],
      },
      {
        _id: "menu-start-your-business-child-8",
        name: "Important Information",
        link: "/start-your-business/important-information",
        children: [],
      },
    ],
  },
  {
    _id: "menu-our-services-parent",
    name: "Our Services",
    link: "/our-services",
    children: [
      {
        _id: "menu-our-services-child-1",
        name: "Administrative Services",
        link: "/our-services/administrative-services",
        children: [],
      },
      {
        _id: "menu-our-services-child-2",
        name: "License",
        link: "/our-services/license-services",
        children: [],
      },
      {
        _id: "menu-our-services-child-3",
        name: "Lease",
        link: "/our-services/lease-services",
        children: [],
      },
      {
        _id: "menu-our-services-child-4",
        name: "Visas",
        link: "/our-services/visas-services",
        children: [],
      },
      {
        _id: "menu-our-services-child-5",
        name: "NOC / Certificates",
        link: "/our-services/noc-certificates",
        children: [],
      },
      {
        _id: "menu-our-services-child-6",
        name: "Registration and Downloads",
        link: "/our-services/registration-and-downloads",
        children: [],
      },
    ],
  },
  {
    _id: "menu-media-center-parent",
    name: "Media Center",
    link: "/media-center/news-%26-events",
    children: [
      {
        _id: "menu-media-center-child-1",
        name: "Photo Gallery",
        link: "/media-center/photo-gallery",
        children: [],
      },
      {
        _id: "menu-media-center-child-2",
        name: "Video Gallery",
        link: "/media-center/video-gallery",
        children: [],
      },
      {
        _id: "menu-media-center-child-3",
        name: "Commercial Movie",
        link: "/media-center/commercial-movie",
        children: [],
      },
    ],
  },
  {
    _id: "menu-investors-corner-parent",
    name: "Investors Corner",
    link: "/investors-corner/business-club",
    children: [
      {
        _id: "menu-investors-corner-child-1",
        name: "Advertise with us",
        link: "/investors-corner/advertise-with-us",
        children: [],
      },
      {
        _id: "menu-investors-corner-child-2",
        name: "Listed Companies Or Investors",
        link: "/investors-corner/listed-companies-or-investors",
        children: [],
      },
    ],
  },
  {
    _id: "menu-contact-us-parent",
    name: "Contact Us",
    link: "/contact-us",
    children: [],
  },
  {
    _id: "menu-faqs-parent",
    name: "FAQs",
    link: "/faqs/category",
    children: [],
  },
];
